import React from "react";
import {useParams, NavLink} from "react-router";
import {ArrowBackIos} from "@mui/icons-material";
import {Button, Paper, Stack, Box, Typography} from "@mui/material";
import TimberTypeName from "../../components/timberType/TimberTypeDetail/TimberTypeName.tsx";
import {useLocationFormState} from "../../components/timberType/TimberTypeForm/TimberTypeUpdateForm";
import TimberTypeUpdateFormProvider from "../../components/timberType/TimberTypeForm/TimberTypeUpdateFormProvider";
import {useTitle} from 'react-use';
import { Trans } from "@lingui/react/macro";
import { t } from "@lingui/core/macro";

const TimberTypeUpdateEditPage = () => {
    
    useTitle(t`Update Timber Type`);

    const { timberTypeId: id } = useParams();
    
    return (
        <Box data-testid="TimberType-update-form">
            <Paper sx={ { padding: "2em" } }>
                <Stack direction="column" spacing={1}>
                    <Typography
                        sx={ { flex: '1 1 100%' } }
                        variant="h6"
                        component="div"
                        data-testid="TimberType-update-title"
                    >
                        <Trans>Edit Timber Type</Trans>:  <TimberTypeName id={id}/>
                    </Typography>
                    <TimberTypeUpdateFormProvider
                        id={id}
                        cancelButton={
                            <Button size="medium" variant="contained" color="inherit" startIcon={<ArrowBackIos />}
                                    component={NavLink}
                                    to=".."
                                    relative="path"
                                    viewTransition={true}
                            >
                                <Trans>Cancel</Trans>
                            </Button>
                        }
                        initialFormState={useLocationFormState}
                    />
                </Stack>
            </Paper>
        </Box>
    )
}

export default TimberTypeUpdateEditPage;
